module.exports = __webpack_public_path__ + "media/images/home/road-background-d151ab2f1b1d05ea66c46c56f11c60de.svg";